import {format, getISOWeek} from "date-fns";

const capitalizeFirstLetter = (value) => {
    if (value && value.length > 1) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
}

const convertDate = (date) => {
    if (date) {
        let day = new Date(date)
        let numberDay = day.getDate()
        let month = new Date(date)
        let numberMonth = month.getMonth()
        let year = new Date(date)
        let numberYear = year.getFullYear()
        return format(new Date(numberYear, numberMonth, numberDay+1), 'yyyy-MM-dd')
    }
    return date;
}

const convertDate2 = (date) => {
    if (date) {
        let day = new Date(date)
        let numberDay = day.getDate()
        let month = new Date(date)
        let numberMonth = month.getMonth()
        let year = new Date(date)
        let numberYear = year.getFullYear()
        return format(new Date(numberYear, numberMonth, numberDay), 'yyyy-MM-dd')
    }
    return date;
}

const convertDate3 = (date) => {
    if (date) {
        let day = new Date(date)
        let numberDay = day.getDate()
        let month = new Date(date)
        let numberMonth = month.getMonth()
        let year = new Date(date)
        let numberYear = year.getFullYear()
        return format(new Date(numberYear, numberMonth, numberDay - 1), 'yyyy-MM-dd')
    }
    return date;
}

const getWeekNumberCurrent = (date) => {
    const currentDate = date instanceof Date ? date : new Date();
    return getISOWeek(currentDate);
}
const convertStartDateWithTime = (date) => {
    if (!date) return date;
    const dateStr = typeof date === 'string' ? date.split('T')[0] : date;
    return `${dateStr}T00:00:00-05:00`;
}

const convertEndDateWithTime = (date) => {
    if (!date) return date;
    const dateStr = typeof date === 'string' ? date.split('T')[0] : date;
    return `${dateStr}T23:59:59-05:00`;
}

const formatPrice = (price) => {
    if (price) {
        return `$ ${(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    }
    return price;
}

const convertTime = time => {
    if (time) {
        return time.slice(0, 5);
    }
}

export {capitalizeFirstLetter, convertDate, convertDate2, formatPrice, convertTime, getWeekNumberCurrent, convertEndDateWithTime, convertStartDateWithTime, convertDate3}